import { Quote } from "lucide-react";

export const Testimonial = () => (
    <section className="py-20 lg:py-28 border-t border-white/[0.06]" aria-labelledby="testimonial-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-start">
                <div className="lg:col-span-2">
                    <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-emerald-400">Aus der Praxis</p>
                    <h2 id="testimonial-heading" className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white">
                        Was nach den ersten Wochen übrig bleibt: Ruhe.
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-[#9CA3AF] leading-relaxed">
                        Keine Theorie – so fühlt sich die Arbeit an, wenn die Routine im Hintergrund läuft.
                    </p>
                </div>
                <figure data-testid="testimonial-card" className="lg:col-span-3 rounded-2xl border border-white/[0.08] bg-[#161F30] p-8 sm:p-10">
                    <Quote className="h-8 w-8 text-emerald-500/60" aria-hidden="true" />
                    <blockquote className="mt-6 text-lg sm:text-xl text-white leading-relaxed font-medium">
                        „Unsere Eigentümer bekommen Antworten auf Standardfragen inzwischen in Minuten – nicht
                        erst am nächsten Tag. Und mein Team hat endlich wieder zusammenhängende Zeit für die
                        Fälle, die wirklich jemanden brauchen. Ehrlich gesagt: Zurück wollen wir nicht.“
                    </blockquote>
                    <figcaption className="mt-8 flex items-center gap-4">
                        <span
                            className="flex h-11 w-11 items-center justify-center rounded-full bg-emerald-500/15 border border-emerald-500/30 font-heading font-semibold text-emerald-400"
                            aria-hidden="true"
                        >
                            SN
                        </span>
                        <span>
                            <span data-testid="testimonial-author" className="block text-sm font-semibold text-white">
                                Sandra Neumann
                            </span>
                            <span data-testid="testimonial-role" className="block text-sm text-[#9CA3AF]">
                                Geschäftsführerin, Hausverwaltung Neumann &amp; Partner, Essen
                            </span>
                        </span>
                    </figcaption>
                    <p className="mt-6 text-xs text-[#6B7280]">Kundenstimme aus der Pilotphase.</p>
                </figure>
            </div>
        </div>
    </section>
);
